<template>
    <div>
        <template>
            <b-row>
                <b-col md="10">
                    <text-header id="atmo-contract">Договор</text-header>
                </b-col>
            </b-row>
            <template v-if="purchase.contract">
                <purchase-contract-info :purchase="purchase" />
                <contract-files-table :contract="purchase.contract" :download-zip="downloadZip" :is-data-sending="isDataSending" :download-pdf="downloadPdf" />
                <sign-contract-button v-if="purchase.actions.supplier.contract === 'sign'" :disabled="!$store.getters.getCanSign" :is-data-sending="isDataSending" @click="showConfirmModal = true" />
                <disagreement-table v-if="purchase.contract.disagreements.length > 0" :disagreements="purchase.contract.disagreements" />
                <template v-if="purchase.actions.supplier.contract === 'sign'">
                    <b-row>
                        <b-col md="10">
                            <text-header id="atmo-contract">Согласование разногласий по договору</text-header>
                        </b-col>
                    </b-row>
                    <b-overlay :show="isDataSending" opacity="0.6" rounded spinner-small spinner-variant="primary">
                        <form-row-contract-upload v-model="form.attachment" :disabled="!$store.getters.getCanSign" :label-cols-lg="3" :v="$v.form.attachment" send-title="Подписать и отправить протокол разногласий" title="Протокол разногласий" with-send @send="showDisagreementModal = true" />
                    </b-overlay>
                    <template v-if="!$store.getters.getCanSign">
                        <div v-if="$store.getters.getLoginType === 'cert'" class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">
                            Для действия требуется загрузить/заменить МЧД на странице:
                            <router-link :to="{ name: 'CabinetUserProfile' }" class="green-link">Данные учетной записи</router-link>
                        </div>
                        <div v-else class="text-danger pl-3 pt-0 fs-14 w-50 my-auto">Подписание возможно только при авторизации при помощи ЭЦП</div>
                    </template>
                </template>
            </template>
        </template>
        <sign-file-modal :attachment="purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment" :show="showConfirmModal" title="Подписание договора поставщиком" @close="showConfirmModal = false" @submit="storeSignedContract" />
        <sign-file-modal v-if="form.attachment" :attachment="form.attachment" :show="showDisagreementModal" title="Отправка подписанного протокола разногласий" with-comment @close="showDisagreementModal = false" @submit="storeSignedDisagreement" />
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { getCertificate } from 'crypto-pro';
import ContractFilesTable from '@/components/products/fl223/partials/contract-files-table.vue';
import SignContractButton from '@/components/products/fl223/partials/sign-contract-button.vue';
import PurchaseContractInfo from '@/components/products/fl223/partials/purchase-contract-info.vue';
import FileDownload from 'js-file-download';
import DisagreementTable from '@/components/products/fl223/partials/disagreement-table.vue';
import FormRowContractUpload from '@/components/common/form-rows/form-row-contract-upload.vue';

export default {
    name: 'private-fl223-contract-supplier-block',
    components: { FormRowContractUpload, DisagreementTable, PurchaseContractInfo, SignContractButton, ContractFilesTable },
    props: {
        purchase: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            showConfirmModal: false,
            showDisagreementModal: false,
            form: {
                attachment: null
            },
            isDataSending: false,
            fields: [
                { key: 'created_at', label: 'Дата и время', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '200px', maxWidth: '200px' } },
                { key: 'contract_attachment', label: 'Документ', sortable: false, tdClass: 'align-text-top py-1', thClass: 'text-nowrap py-1' },
                { key: 'sign_customer', label: 'Подпись заказчика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } },
                { key: 'sign_supplier', label: 'Подпись поставщика', sortable: false, tdClass: 'align-text-top text-nowrap py-1', thClass: 'py-1', thStyle: { width: '50px' } }
            ]
        };
    },
    validations() {
        return {
            form: {
                attachment: {
                    required
                }
            }
        };
    },
    methods: {
        async send() {
            this.isDataSending = true;
            if (await this.$api.products.fl223.contracts.store(this.purchase.id, this.form.attachment)) {
                this.$emit('refresh');
            }
            this.isDataSending = false;
        },
        async storeSignedContract(signature) {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                signed_attachment: {
                    id: this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id,
                    md5: signature.signature
                }
            };
            if (await this.$api.products.fl223.contracts.storeSigned(this.purchase.id, this.purchase.contract.id, 'supplier', data)) {
                this.$emit('refresh');
                this.showConfirmModal = false;
            }
            this.isDataSending = false;
        },
        async storeSignedDisagreement(signature) {
            this.isDataSending = true;
            const data = {
                certificate: await getCertificate(this.$store.getters.getCurrentThumbprint),
                comment: signature.comment,
                signed_attachment: {
                    id: this.form.attachment.id,
                    md5: signature.signature
                }
            };
            if (await this.$api.products.fl223.contracts.storeSignedDisagreement(this.purchase.id, this.purchase.contract.id, 'supplier', data)) {
                this.showDisagreementModal = false;
                this.$emit('refresh');
            }
            this.isDataSending = false;
        },
        downloadZip() {
            this.$api.products.fl223.contracts
                .downloadZip(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.zip_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        },
        downloadPdf() {
            this.$api.products.fl223.contracts
                .downloadPrintForm(this.purchase.id, this.purchase.contract.id, this.purchase.contract.contract_files.find((file) => !file.is_archived).contract_attachment.id)
                .then((response) => {
                    FileDownload(response.data, this.purchase.contract.pdf_name);
                })
                .catch((error) => {
                    this.showError(error);
                });
        }
    }
};
</script>
